import { action, observable, makeObservable } from 'mobx';

/**
 * Guarda qual processo tem a minuta sendo exibida no modal de pré-visualização,
 * para que a lista de processos consiga destacar a linha correspondente.
 */
class VisualizacaoMinutaStore {
    identificadorProcesso: number | null = null;

    constructor() {
        makeObservable(this, {
            identificadorProcesso: observable,
            definirProcesso: action,
            limpar: action
        });
    }

    definirProcesso = (identificadorProcesso: number) => {
        this.identificadorProcesso = identificadorProcesso ?? null;
    };

    limpar = () => {
        this.identificadorProcesso = null;
    };
}

export default new VisualizacaoMinutaStore();
